import { SET_AUCTION_LOGO, SET_AUCTION_SLUG } from "../../Actions/auction";
import { LOGO } from "../../../..";

const initialState = {
  logo: LOGO,
  slug: "",
};

export default function auctionReducer(state = initialState, action) {
  switch (action.type) {
    case SET_AUCTION_LOGO:
      return { ...state, logo: action.payload };
    case SET_AUCTION_SLUG:
      return { ...state, slug: action.payload };
    default:
      return state;
  }
}
